import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SmartDeviceStoreModule } from './store/devices'
import { SmartDeviceAccessStoreModule } from './store/code/module'

@NgModule({
  imports: [CommonModule, SmartDeviceStoreModule, SmartDeviceAccessStoreModule],
})
export class SmartDevicesLibraryModule {}
